import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class DeltaworldService {
  private uri = ``;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
  ) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  GetDeltaWorld() {
    // 1040
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_DeltaWorld'
    });
  }

  GetEstimateProgramerAddObjects(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimateProgramerAddObjects', systemtypeid: id
    })
  }

  GetMasterEstimateProgramerAddObjects(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_MasterEstimateProgramerAddObjects', systemtypeid: id
    })
  }

  GetEstimateSystemType() {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimateSytemTypeAll'
    })
  }

  GetMasterEstimateSystemType() {
    // Get_MasterEstimateSytemTypeAll
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'GetMasterSystemType'
    })
  }

  GetEstimateSystemTypeCE() {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimateSytemTypeCE'
    })
  }

  GetEstimateSystemTypeCEClient(dbcode) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_ClientEstimateSytemTypeCE', dbcode: dbcode
    })
  }

  GetEstimateSystemTypeCEMaster() {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimateSytemTypeCEMaster'
    })
  }

  GetSystemArea(id, viewtypeid = 1) {
    // 1040
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_AreaSystemAllCE2', estimateid: id, viewtypeid
      //Get_AreaSystemAllCE, Get_AreaSystemAll, Get_AreaSystemAllCE-2
    });
  }

  GetEstimatesSystemProgramDetailAll(id, modeid = 1) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimatesSystemProgramDetail', systemid: id, modeid: modeid
    });
  }

  GetEstimatesSystemProgramInfoAll(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimatesSystemProgramInfoAll', systemid: id
    });
  }

  Get_EstimatesSystemProgramInfoSeq(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimatesSystemProgramInfoSeq', systemid: id
    });
  }
  
  Get_EstimatesSystemIOAll(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimatesSystemIOAll', systemid: id, CR:true
    });
  }

  Get_ECOMMEstimatesSystemIOAll(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_ECOMMEstimatesSystemIOAll', systemid: id, CR:true
    });
  }

  GetEstimateAreaList(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'GetEstimateAreaList', estimateid: id
    });
  }

  GetEstimateAreaSystemInfo(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'GetEstimateAreaSystemInfoCE', systemid: id
    });
  }


  UpdateEstimateRevisionDetail(id,pointnumber, sched, tendlog, event, setpoint, co,os, appnotes, pgprefixed, dwgref, tag) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'update_EstimateRevisionDetailpg',
      pointnumber: pointnumber,
      pgprefixed: pgprefixed,
      sched: sched,
      trendlog: tendlog,
      event: event,
      setpoint: setpoint,
      co: co,
      os: os,
      id: id,
      appnotes: appnotes,
      dwgref: dwgref,
      tag: tag
    });
  }

  InsertEstimateProdAddObject(systemid, objids) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Insert_EstimateProdAddObjects', systemid: systemid, ObjectId: objids
    });
  }

  DeleteEstimateProdAddObject(systemid, objids) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Delete_EstimateProdAddObjects', systemid: systemid, ObjectId: objids
    });
  }

  GetControllerMasterData(systemid) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_ControllerMasterData', systemid: systemid
    });
  }

  GetScopeOfWorkSC(systemid, estimateid) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_SingleScopeOfWorkSC', systemid: systemid, estimateid:estimateid
    });
  }

  GetEstimateObjectReferences() {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_EstimateObjectReferences'
    });
  }

  GetMasterEstimateObjectReferences() {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_MasterEstimateObjectReferences'
    });
  }

  UpdateEstimateDetBACData(systemid, bacadd, macadd, rs485net1from, rs485net1to, rs485net2from, rs485net2to, cubebox, systemparentid) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Update_EstimateDetBACData',
      systemid: systemid,
      bacadd: bacadd,
      macadd: macadd,
      rs485net1from: rs485net1from,
      rs485net1to: rs485net1to,
      rs485net2from: rs485net2from,
      rs485net2to: rs485net2to,
      cubebox: cubebox,
      systemparentid: systemparentid
    });
  }
}
